import React from 'react';
import { Link } from 'react-router-dom';
import styles from './navbutton.module.css';
import { TNuvButton } from '../../utils/types';
import { onPanelLinkClick, onPanelLinkHover } from '../../utils/panelLink';
import imageKey from '../../images/key.svg';
import imageForum from '../../images/forum.svg';
import imageRules from '../../images/rules.svg';
import { isSiteRoute } from '../../utils/publicRoutes';
import imageNews from '../../images/news.svg';

const NavButton: React.FC<TNuvButton> = ({children, image, link}) => {
  let img;
  switch (image) {
    case 'key':
      img = imageKey;
      break
    case 'forum':
      img = imageForum;
      break
    case 'rules':
      img = imageRules;
      break
    case 'news':
      img = imageNews;
      break
    default:
      img = '';
      break
  };

  const content = (
    <>
      <img className={styles.img} src={img} alt="" />
      <p className={styles.text}>{children}</p>
    </>
  );
  // Страницы сайта открываем без перезагрузки (плавный переход), внешние
  // ссылки и кабинет — обычной ссылкой
  if (isSiteRoute(link)) {
    return <Link className={styles.link} to={link}>{content}</Link>;
  }
  if (link.startsWith('/panel')) {
    return (
      <a className={styles.link} href={link} onClick={e => onPanelLinkClick(e, link)} onMouseEnter={onPanelLinkHover} onFocus={onPanelLinkHover}>
        {content}
      </a>
    );
  }
  return <a className={styles.link} href={link}>{content}</a>;
}

export default NavButton;
